import numeral from "numeral";
import React from "react";

interface IPageResultsCount {
  count: number;
  prefix?: string;
  postfix?: string;
  showCount?: boolean;
}

export function formatCount(count: number) {
  if (!count) return "0";
  const numeralFormat = count > 1100 ? "0.0a" : "0a";
  return numeral(count).format(numeralFormat).toUpperCase();
}

const PageResultsCount: React.FC<IPageResultsCount> = ({
  count = 0,
  prefix = "",
  postfix = "",
  showCount = true
}) => {
  const text = formatCount(count);
  return <>{showCount && `${prefix}${text}${postfix}`}</>;
};

export default PageResultsCount;
